import MUILink from '@material-ui/core/Link';
import React from 'react';
import { Link } from 'react-router-dom';

export default React.forwardRef(
  ({ href, target, to, state, component, underline = 'none', color = 'inherit', ...rest }, ref) => {
    const toWithState = to && state ? { pathname: to, state } : to;
    return (
      <MUILink
        ref={ref}
        color={color}
        underline={underline}
        component={to ? Link : component}
        to={toWithState}
        href={href}
        target={href ? '_blank' : target}
        {...rest}
      />
    );
  }
);
